// Filename: collections/activitys
define('collections/calendar/session/tags',[
    'underscore', 'backbone', 'mustache', 'moment', 'utils',
    // src
    'services/api',
    // super class
    'src/plugins/infinite-collection',
    // Pull in the Model module from above
    'models/calendar/session/tag'
], function(
    // libs
    _, Backbone, Mustache, moment, U, API,
    // super class
    InfiniteCollection,
    // model
    MTag
) {

    var CTags = InfiniteCollection.extend({
        model: MTag,
        url: function() {
            if (this.custom) {
                return API.url(Mustache.render("groups/{{{group}}}/exercises/tags/", {
                    group: this.group
                }));
            }

            return API.url("exercises/tags/");
        },
        comparator: function(model) {
            return model.get('name').toLowerCase();
        },

        initialize: function(models, opt) {
            opt = opt || {};
            this.custom = opt.custom;
            this.setGroup(opt.group);
        },

        setGroup: function(groupId) {
            this.group = groupId;
        },

        getStringNames: function() {
            var names = "",
                isLast = false,
                cpt = 1;

            this.every(function(model, i) {
                isLast = i === this.length - 1;
                names += model.get('name');
                cpt++;

                if (this.length <= 4 && isLast) {
                    names += "";
                } else {
                    names += isLast || i === 4 ? "..." : ", ";
                }

                return i !== 4;
            }, this);

            return names;
        },

        findByName: function(name) {
            for (var i = 0; i < this.models.length; i++) {
                var arrSubTag = this.models[i].getSubtags() || {};
                for (var j = 0; j < arrSubTag.length; j++) {
                  if (arrSubTag[j].trName.toLowerCase() === name)
                    return arrSubTag[j];
                }
            }
            return null;
        },
    });

    return CTags;
});

